import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import React from 'react';
import { TELEGRAM_DOMAIN, TELEGRAM_LINK } from 'utils/constants';

export function TelegramSupportLink() {
  return (
    <LinkControlComponent to={TELEGRAM_LINK}>
      <TextComponent color="accent" animatedColor>
        {`@${TELEGRAM_DOMAIN}`}
      </TextComponent>
    </LinkControlComponent>
  );
}
